module.exports = __webpack_public_path__ + "static/media/vintage-wallpaper.78ee9c8a.png";